import { getCookie } from "/services/cookies-service";
import { LAST_ACCOUNT_SLUG } from "constants/cookies";
import * as Sentry from "@sentry/nextjs";

export const ACTIVE_ACCOUNTS_SLUGS_COOKIE_NAME = "monday_active_account_slugs"; // set in the platform after each login expiry 1 year
const ALL_SLUGS_COOKIE_NAME = "dapulseAccountSlugs"; // set in the platform after each login - session cookie no expiration
export const SLUG_DETAILS_COOKIE_NAME = "monday_slug_details"; // set in the platform after each login - saves up to 5 last slugs

// Returns array of slug names (string)
export const getMondayActiveSlugs = () => {
  let slugsFromCookie = getCookie(ACTIVE_ACCOUNTS_SLUGS_COOKIE_NAME);
  let slugs = [];
  if (slugsFromCookie) {
    try {
      slugsFromCookie = decodeURIComponent(slugsFromCookie);
      slugs = JSON.parse(slugsFromCookie);
    } catch (err) {
      Sentry.captureException(err);
    }
  }
  return slugs;
};

// Array of objects with the following structure:
// {user_name, user_email, user_image, account_name, slug, account_created(only for new accounts)}
export const getMondaySlugsDetails = () => {
  let slugsFromCookie = getCookie(SLUG_DETAILS_COOKIE_NAME);
  let slugsDetails = [];
  if (slugsFromCookie) {
    try {
      slugsFromCookie = decodeURIComponent(slugsFromCookie);
      slugsDetails = JSON.parse(slugsFromCookie);
    } catch (err) {
      Sentry.captureException(err);
    }
  }
  return slugsDetails;
};

export const getLastUsedAccountSlug = () => {
  return getCookie(LAST_ACCOUNT_SLUG);
};

export const getMondayFullUrlForSlug = (slug) => {
  return `//${slug}.${process.env.NEXT_PUBLIC_AUTH_PLATFORM_DOMAIN}`; // works also in client side (next trick)
};

export const validateAllAccountsCreatedAfterDate = (date) => {
  try {
    const slugs = getMondaySlugsDetails();
    const newSlugs = slugs.filter((slug) => slug.account_created && new Date(slug.account_created) >= date);
    return newSlugs.length === slugs.length;
  } catch (err) {
    Sentry.captureException(err);
    return false;
  }
};
